/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { INutritionPlanIP } from 'app/shared/model/nutrition-plan-ip.model';
import { ITreatmentPlan } from 'app/shared/model/treatment-plan.model';
import { INutritionOrder } from 'app/shared/model/nutrition-order.model';
import { MealStatus } from 'app/shared/model/enumerations/meal-status.model';

export interface IMealPlan {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  plannedAt?: number;
  delveredAt?: number;
  consumedAt?: number;
  instructions?: string;
  status?: keyof typeof MealStatus | null;
  nutritionPlan?: INutritionPlanIP | null;
  treatmentPlan?: ITreatmentPlan;
  nutritionOrder?: INutritionOrder | null;
}

export const defaultValue: Readonly<IMealPlan> = {
  active: false,
};
